import { Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "@/features/auth/LoginPage";
import { RequireAuth } from "@/features/auth/RequireAuth";
import { PortalPage } from "@/features/portal/PortalPage";
import { MembershipPortalPage } from "@/features/portal/MembershipPortalPage";
import { PartyPortalPage } from "@/features/portal/PartyPortalPage";
import { PartyInquiryPage } from "@/features/portal/PartyInquiryPage";
import { AppShell } from "@/components/AppShell";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { PipelinePage } from "@/features/pipeline/PipelinePage";
import { QuotesPage } from "@/features/quotes/QuotesPage";
import { QuoteDetailPage } from "@/features/quotes/QuoteDetailPage";
import { EventsPage } from "@/features/events/EventsPage";
import { EventDetailPage } from "@/features/events/EventDetailPage";
import { EventCalendarPage } from "@/features/events/EventCalendarPage";
import { MoneyPage } from "@/features/money/MoneyPage";
import { InvoiceDetailPage } from "@/features/money/InvoiceDetailPage";
import { FinancesPage } from "@/features/finance/FinancesPage";
import { OutreachPage } from "@/features/outreach/OutreachPage";
import { CampaignsPage } from "@/features/campaigns/CampaignsPage";
import { CampaignDetailPage } from "@/features/campaigns/CampaignDetailPage";
import { ContactsPage } from "@/features/contacts/ContactsPage";
import { ContactDetailPage } from "@/features/contacts/ContactDetailPage";
import { ReviewsPage } from "@/features/reviews/ReviewsPage";
import { MarketingPage } from "@/features/marketing/MarketingPage";
import { SecurityPage } from "@/features/security/SecurityPage";
import { SquarePage } from "@/features/square/SquarePage";
import { ReconciliationPage } from "@/features/reconciliation/ReconciliationPage";
import { CalendarPage } from "@/features/calendar/CalendarPage";
import { FunnelPage } from "@/features/analytics/FunnelPage";
import { BookingsPage } from "@/features/bookings/BookingsPage";
import { MembersPage } from "@/features/memberships/MembersPage";
import { MemberDetailPage } from "@/features/memberships/MemberDetailPage";
import { StudioPage as MembersStudioPage } from "@/features/memberships/StudioPage";
import { StudioPage } from "@/features/studio/StudioPage";
import { ClassesPage } from "@/features/classes/ClassesPage";
import { SectionRosterPage } from "@/features/classes/SectionRosterPage";
import { ClassRegistrationPage } from "@/features/portal/ClassRegistrationPage";
import { PartiesPage } from "@/features/parties/PartiesPage";
import { PractitionersPage } from "@/features/practitioners/PractitionersPage";
import { PractitionerDetailPage } from "@/features/practitioners/PractitionerDetailPage";

export function App() {
  return (
    <Routes>
      {/* Public routes — no auth, no app shell */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/portal" element={<PortalPage />} />
      <Route path="/membership-portal" element={<MembershipPortalPage />} />
      <Route path="/register-classes" element={<ClassRegistrationPage />} />
      <Route path="/party-portal" element={<PartyPortalPage />} />
      <Route path="/parties/inquire" element={<PartyInquiryPage />} />

      {/* Authenticated app routes */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/contacts" replace />} />
        <Route path="studio" element={<StudioPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="analytics" element={<FunnelPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="members" element={<MembersPage />} />
        <Route path="members/studio" element={<MembersStudioPage />} />
        <Route path="members/:id" element={<MemberDetailPage />} />
        <Route path="classes" element={<ClassesPage />} />
        <Route path="classes/sections/:id" element={<SectionRosterPage />} />
        <Route path="parties" element={<PartiesPage />} />
        <Route path="practitioners" element={<PractitionersPage />} />
        <Route path="practitioners/:id" element={<PractitionerDetailPage />} />
        <Route path="reconciliation" element={<ReconciliationPage />} />
        <Route path="pipeline" element={<PipelinePage />} />
        <Route path="quotes" element={<QuotesPage />} />
        <Route path="quotes/:id" element={<QuoteDetailPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="events/calendar" element={<EventCalendarPage />} />
        <Route path="events/:id" element={<EventDetailPage />} />
        <Route path="money" element={<MoneyPage />} />
        <Route path="money/:id" element={<InvoiceDetailPage />} />
        <Route path="square" element={<SquarePage />} />
        <Route path="finances" element={<FinancesPage />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="marketing" element={<MarketingPage />} />
        <Route path="outreach" element={<OutreachPage />} />
        <Route path="campaigns" element={<CampaignsPage />} />
        <Route path="campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="contacts/:id" element={<ContactDetailPage />} />
        <Route path="security" element={<SecurityPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/contacts" replace />} />
    </Routes>
  );
}
